const fr = {
  common: {
    // Indicador global de datos simulados (MockDataBadge). Ver docs/contexto/decisiones.md D-8.
    mockData: 'Données de démonstration',
    mockDataHint: "Le service de Reconnaissance n'est pas encore déployé : cet écran est alimenté par des données simulées au sein même de l'application.",
    loading: 'Chargement...',
    error: 'Erreur',
    documentNotAvailable: "Ce document n'est pas disponible pour le moment. Cela peut dépendre de votre langue ou de votre unité ; contactez votre administrateur si le problème persiste.",
    sessionExpiredMessage: "Votre session a expiré. Enregistrez ce que vous pouvez et reconnectez-vous.",
    reload: 'Se reconnecter',
    save: 'Enregistrer',
    cancel: 'Annuler',
    delete: 'Supprimer',
    edit: 'Modifier',
    moveUp: 'Monter',
    moveDown: 'Descendre',
    close: 'Fermer',
    download: 'Télécharger',
    confirm: 'Confirmer',
    search: 'Rechercher',
    filter: 'Filtrer',
    export: 'Exporter',
    yes: 'Oui',
    no: 'Non',
    back: 'Retour',
    next: 'Suivant',
    submit: 'Soumettre',
    darkMode: 'Mode sombre',
    lightMode: 'Mode clair',
    languageMenuTitle: 'Changer de langue',
    logout: 'Se déconnecter',
    pagerShow: 'Afficher',
    pagerPerPage: 'par page',
    pagerOf: 'sur',
    viewCards: 'Vue cartes',
    viewList: 'Vue liste',
    collapse: 'Réduire',
    expand: 'Développer',
    previousPage: 'Page précédente',
    nextPage: 'Page suivante',
    retry: 'Réessayer',
    errorBoundaryTitle: "Une erreur s'est produite",
    errorGeneric: "Une erreur inattendue s'est produite. Veuillez réessayer.",
    expandModal: 'Agrandir en modal',
    resetToGlobal: 'Réinitialiser au global',
    appName: 'Sigma Pulse',
  },
  nav: {
    home: 'Accueil',
    growth: 'Croissance',
    admin: 'Administration',
    executive: 'Exécutif',
    analytics: 'Analytique',
    switchDemoProfile: 'Changer le profil de démonstration',
    mobileNav: 'Navigation principale',
    fundamentals: 'Fondamentaux',
    usersAdmin: 'Administrateurs',
    recognitionSection: 'Reconnaissances',
    language: 'Langue',
    collapseMenu: 'Réduire le menu',
    expandMenu: 'Développer le menu',
  },
  roles: {
    employee: 'Employé',
    adminOU: 'Admin UO Pulso',
    adminGlobal: 'Admin Général',
    adminPulso: 'Admin Pulso',
    adminBrillamos: 'Admin Brillamos',
    adminOUBrillamos: 'Admin UO Brillamos',
  },
  access: {
    noModulesTitle: 'Aucun accès aux modules',
    noModulesDesc: 'Votre compte n\'a ni Pulso ni Reconnaissance activé. Demandez l\'accès à l\'administrateur de votre organisation.',
  },
  platform: {
    teams: 'TEAMS',
  },
  survey: {
    title: 'Enquêtes en attente',
    pending: 'En attente',
    completed: 'Complétée',
    expired: 'Expirée',
    submit: "Soumettre l'évaluation",
    skip: 'Ignorer',
    noObs: 'Sans observation',
    meeting: 'Réunion',
    duration: 'Durée',
    participants: 'Participants',
    simulateMeeting: 'Simuler la fin de réunion',
    thankYou: 'Merci pour votre évaluation !',
    evaluating: 'Évaluation de',
    of: 'de',
    question: 'Question',
    selectResponse: 'Sélectionnez une réponse',
    nps: {
      question: 'Quelle est la probabilité que vous recommandiez de travailler avec cette personne ?',
      detractor: 'Détracteur',
      passive: 'Passif',
      promoter: 'Promoteur',
    },
    evaluateNow: 'Évaluer maintenant',
    postpone: 'Plus tard',
    expires: 'Expire',
    noSurveysPending: 'Aucune enquête en attente ! Bon travail.',
    weekCompleted: 'sem.',
    likert: {
      always: 'Toujours',
      usually: 'Presque toujours',
      sometimes: 'Parfois',
      rarely: 'Rarement',
      notObservable: 'Non observable',
    },
    questions: {
      listenedActivelyText: 'Cette personne a-t-elle écouté activement et montré un intérêt sincère ?',
      sharedKnowledgeText: 'A-t-elle partagé des connaissances ou des expériences pertinentes lors de la session ?',
    },
    completeSubtitle: "Vos retours contribuent à renforcer la culture de l'équipe.",
    backToHome: "Retour à l'accueil",
    greetingMorning: 'Bonjour',
    greetingAfternoon: 'Bonne après-midi',
    greetingEvening: 'Bonsoir',
    pendingCountPre: 'Vous avez',
    pendingCountSingular: 'enquête en attente',
    pendingCountPlural: 'enquêtes en attente',
    allDoneTitle: 'Tout est à jour !',
    allDoneSubtitle: 'Vous n\'avez pas d\'enquêtes en attente. Elles apparaîtront ici après votre prochaine réunion.',
    omit: 'Ignorer',
    omitSurvey: 'Ignorer l\'enquête',
    submitSuccess: 'Réponses envoyées',
    submitError: 'Erreur d\'envoi — réessayez',
    omitSuccess: 'Enquête ignorée',
    omitError: 'Erreur — réessayez',
    unavailableError: `Cette enquête n'est plus disponible`,
    kpi: {
      answered: 'Répondues',
      omitted: 'Ignorées',
      streak: 'Série',
      participation: 'Participation',
    },
    growth: {
      title: 'Votre croissance vous attend',
      message: 'Consultez vos résultats, tendances et axes de développement dans votre tableau de bord.',
      cta: 'Voir ma progression',
    },
    recognition: {
      title: 'Brillons Ensemble',
      message: 'Reconnaissez vos collègues et célébrez leurs réussites dans le Programme de Reconnaissance.',
      cta: 'Aller à la Reconnaissance',
    },
    tips: {
      title: 'Conseils pour vous',
      based: 'Basés sur votre score moyen',
      empty: 'Complétez plus d\'enquêtes pour voir des conseils personnalisés',
      reconocer: 'Pour reconnaître',
      crecer: 'Pour progresser',
      tipOfDay: 'Conseil du jour',
    },
  },
  safe: {
    title: 'Ma Croissance',
    subtitle: 'Votre développement culturel chez Sigma',
    sectionName: 'Mon feedback',
    surveysAnswered: 'Sondages répondus',
    score: 'Votre Score',
    evolution: 'Votre évolution',
    evolutionSub: 'Votre parcours personnel — juste vous, sans comparaisons',
    radarTitle: 'Votre profil par Fondamental',
    radarSub: 'Vous aujourd\'hui vs vous il y a 3 mois',
    fundamentals: 'Fondamentaux',
    fundamentalsChart: 'Votre feedback par Fondamental',
    fundamentalsChartSub: 'Où vous en êtes sur chacun — cliquez sur une barre pour le détail',
    behaviors: 'Comportements',
    kudos: 'Reconnaissances',
    kudosTitle: 'Pour Reconnaître — ce que vous apportez le plus',
    kudosSub: 'Ce que vos collègues observent le plus chez vous ce mois',
    actions: "Plan d'action",
    omissions: 'Omissions',
    period: 'Période',
    received: 'Reçues',
    sent: 'Envoyées',
    areaAverage: 'Moyenne de zone',
    today: "Aujourd'hui (les {{days}} derniers jours)",
    threeMonthsAgo: 'Il y a 3 mois (fenêtre de {{days}} jours)',
    detail: 'Détail',
    profileTitle: 'Votre profil culturel en mots',
    profileSub: 'Comportements, pas chiffres',
    basedOn: 'Basé sur {{count}} feedbacks anonymes',
    level0: 'Débutant',
    level1: 'En développement',
    level2: 'Régulier',
    level3: 'Référent',
    level0desc: "Attend que les autres résolvent les problèmes ou éliminent les obstacles.",
    level1desc: "Tente de résoudre les obstacles mais abandonne rapidement ou fait remonter l'information prématurément.",
    level2desc: "Prend l'initiative de lever les obstacles et de trouver des solutions pour avancer.",
    level3desc: "Inspire les autres à prendre des initiatives et crée un environnement où se débloquer est une responsabilité partagée.",
    levelAbbr0: 'Début',
    levelAbbr1: 'En dév.',
    levelAbbr2: 'Régulier',
    levelAbbr3: 'Référent',
    todayLabel: "Aujourd'hui",
    pointsInMonths: 'points en {{n}} mois',
    monthsWithFeedback: 'mois avec feedback',
    journeyLoading: 'Chargement de ton évolution…',
    journeyEmpty: 'L’historique est encore insuffisant pour tracer ton évolution. Il faut au moins deux mois avec du feedback.',
    journeyChartLabel: 'Évolution de votre moyenne mois par mois',
    thisMonth: 'ce mois',
    headingToLevel: 'En route vers {{level}}',
    maxLevel: 'Niveau maximum !',
    narrativeStrength: "Ce que vous contribuez le plus et mérite reconnaissance est <strong>{{fund}}</strong> — vous êtes au niveau <strong>{{level}}</strong>.",
    narrativeConsistency: 'Vous montrez également de la constance dans {{others}}.',
    narrativeProgress: 'Au cours des 3 derniers mois, vous avez progressé — votre profil montre une croissance.',
    narrativeStable: 'Votre profil est resté stable au cours des 3 derniers mois — cela témoigne de constance.',
    narrativeVariation: 'Votre profil a légèrement varié ces derniers mois. Les variations sont normales et ne vous définissent pas.',
    narrativeNextLevel: 'Votre prochain niveau de croissance est dans <strong>{{fund}}</strong>. La prochaine étape est d\'atteindre le niveau {{level}} — ci-dessous nous vous suggérons une action concrète.',
    act01: 'Reconnaissance — comment les autres vous voient',
    act02: 'Progrès — comment vous avez évolué',
    act03: 'Direction — votre prochaine étape',
    reinforces: 'RENFORCE',
    tryToday: "Je l'essaie aujourd'hui",
    committed: "Je m'engage aujourd'hui !",
    defaultChallenge: "Pratiquez un fondamental aujourd'hui",
    defaultChallengeDesc: 'Choisissez une micro-action et mettez-la en pratique lors de votre prochaine réunion.',
    clickDetail: 'Cliquez pour détail',
    nextLevel: 'NIVEAU SUIVANT',
    growthTitle: 'POUR CONTINUER À GRANDIR',
    growthSub: 'Recommandations basées sur votre feedback',
    feedbacks: 'feedbacks',
    peers: 'collègues',
    givenTitle: 'Ma participation en donnant du feedback',
    givenSub: 'Feedback que vous avez partagé ce mois',
    footerPrivacy: 'Tout le feedback est anonyme. Personne ne peut voir qui vous l\'a donné.',
    footerHeart: 'N\'oubliez pas : le feedback est un cadeau. Ces données reflètent des moments en réunion.',
    personSingular: 'personne',
    personsPlural: 'personnes',
    trend: {
      up: 'Votre profil montre une croissance',
      down: 'Petite variation — c\'est normal',
      stable: 'Profil stable — c\'est de la consistance',
    },
    empty: {
      title: 'Découvrez les Fundamentals',
      desc: "Vous n'avez pas encore assez de retours pour afficher votre tableau de bord. En attendant, explorez les comportements que nous mesurons.",
      hint: 'Votre tableau de bord s’active lorsque vous avez répondu à plus de 3 enquêtes et reçu au moins 3 évaluations de vos collègues.',
      answeredLabel: 'Enquêtes auxquelles vous avez répondu',
      receivedLabel: 'Évaluations que vous avez reçues',
    },
    error: {
      title: 'Impossible de charger votre tableau de bord',
      desc: 'Un problème est survenu lors de la récupération de vos informations. Réessayez ; si cela persiste, prévenez le support.',
      retry: 'Réessayer',
      retrying: 'Nouvel essai…',
    },
    given: {
      loading: 'Chargement de votre historique…',
      empty: "Vous n'avez encore répondu à aucune enquête.",
      loadError: "Impossible de charger l'historique de vos enquêtes complétées.",
      completed: 'Terminée',
      peopleCount_one: '{{count}} personne',
      peopleCount_other: '{{count}} personnes',
    },
    celebration: {
      default: 'Votre façon de travailler marque celles et ceux qui vous entourent.',
      learner: "Votre curiosité et votre ouverture à l'apprentissage inspirent vos collègues.",
      player_owner: "Vous prenez vos responsabilités sans qu'on vous le demande, et cela donne le rythme à l'équipe.",
      psychological_safety: 'Votre écoute donne aux autres le courage de dire ce qu\'ils pensent.',
      collaborate_effectively: "Quand vous collaborez, le travail de tous avance plus vite.",
      quality_of_work: "Votre souci du détail élève le niveau de ce que livre l'équipe.",
      make_others_successful: "Vous veillez à ce que les autres brillent, et toute l'équipe le remarque.",
      explore_experiment: 'Votre envie d\'essayer ouvre des voies que personne n\'avait vues.',
    },
    popup: {
      peersOpined: 'collègues ont évalué',
      evaluationsCount: '{{count}} évaluations',
      subbehaviors: 'Sous-comportements',
      dailyHabits: 'Habitudes quotidiennes',
      monthlyHistory: 'Évolution mensuelle',
      distribution: 'Distribution des feedbacks',
      behaviorScale: 'Échelle de comportement',
      you: 'Vous',
    },
  },
  admin: {
    title: 'Administration',
    menu: {
      general: 'Admin Général',
      pulso: 'Pulso',
      brillamos: 'Brillamos',
    },
    roleAdminGeneral: 'Admin Général',
    roleAdminPulso: 'Admin Pulso',
    roleAdminOUPulso: 'Admin UO Pulso',
    roleAdminBrillamos: 'Admin Brillamos',
    roleAdminOUBrillamos: 'Admin UO Brillamos',
    roleEmployee: 'Employé',
    greetingMorning: 'Bonjour',
    greetingAfternoon: 'Bon après-midi',
    greetingEvening: 'Bonsoir',
    surveys: 'Enquêtes',
    templates: 'Modèles',
    analyticsTab: 'Analytique',
    rulesTab: 'Règles Métier',
    users: 'Utilisateurs',
    notifications: 'Notifications',
    surveysTitle: 'Gestion des Enquêtes',
    searchSurvey: 'Rechercher une enquête...',
    trash: 'Corbeille',
    newSurvey: 'Nouvelle Enquête',
    fundamentalsTab: 'Fondamentaux',
    customTab: 'Personnalisées',
    colName: 'Nom',
    colTitle: 'Titre',
    colDescription: 'Description',
    colQuestions: 'Questions',
    colStatus: 'Statut',
    colAudience: 'Audience',
    sectionCrashed: "Cette section n'a pas pu s'afficher. Réessayez ou choisissez-en une autre.",
    colFrequency: 'Fréquence',
    freqDaily: 'Quotidienne',
    freqWorkdays: 'Jours ouvrés',
    freqWeekly: 'Hebdomadaire · {{day}}',
    freqCustom: '{{count}} jours/semaine',
    freqNone: '—',
    colFeedback: 'Retours',
    colPeriod: 'Période',
    colActions: 'Actions',
    colCreatedBy: 'Créée par',
    creatorUnknown: 'Inconnu',
    colEmail: 'Email',
    colOU: 'UO',
    colUses: 'utilisations',
    statusActive: 'Active',
    statusPaused: 'En pause',
    statusInactive: 'Inactive',
    statusPending: 'En attente',
    anonymous: 'Anonyme',
    duplicate: 'Dupliquer',
    exportExcelTip: 'Exporter Excel',
    templatesTitle: "Modèles d'Enquêtes",
    tipsTab: 'Conseils',
    actionsTab: 'Actions',
    catalogTab: 'Catalogues',
    createTemplate: 'Créer un modèle',
    typeFundamental: 'Fondamental',
    typeCustom: 'Personnalisée',
    placeholderTips: 'Conseils — Module de conseils pour les collaborateurs',
    tplSearchPlaceholder: 'Rechercher un template…',
    tplFilterAll: 'Tous les types',
    tplNoResults: 'Aucun template ne correspond',
    tipsTitle: 'Conseils de Feedback',
    tipsSearchPlaceholder: 'Rechercher un conseil…',
    tipsAllFundamentals: 'Tous les Fondamentaux',
    tipsAllTypes: 'Tous les types',
    tipTypeReconocer: 'Pour Reconnaître',
    tipTypeCrecer: 'Pour Progresser',
    tipsNoResults: 'Aucun conseil ne correspond',
    surveysNoResults: 'Aucun sondage ne correspond à ce critère',
    surveysError: 'Erreur lors du chargement des sondages. Réessayez plus tard.',
    createTip: 'Créer un conseil',
    actionsTitle: 'Actions de Croissance',
    actionsSearchPlaceholder: 'Rechercher une action…',
    actionsNoResults: 'Aucune action ne correspond',
    createAction: 'Créer une action',
    catalogTitle: 'Catalogue de Fondamentaux',
    catalogFundamentals: 'Fondamentaux',
    catalogBehaviors: 'Comportements',
    catalogAddFundamental: 'Ajouter un Fondamental',
    catalogAddBehavior: 'Ajouter un Daily Habit',
    catalogSearchFundamental: 'Rechercher un fondamental…',
    catalogSearchBehavior: 'Rechercher un daily habit…',
    catalogNoBehaviors: 'Aucun daily habit pour ce fondamental',
    catalogSelectFundamental: 'Sélectionnez un Fondamental dans la liste',
    ousTab: 'OU',
    ousTitle: 'Unités Organisationnelles',
    ousSubtitle: 'Gérez les OU racines du tenant',
    ousSearchPlaceholder: 'Rechercher une OU…',
    ousNoResults: 'Aucune OU ne correspond à ce critère',
    createOU: 'Créer une OU',
    editOU: 'Modifier l\'OU',
    deleteOU: 'Supprimer l\'OU',
    deleteOUConfirm: 'Supprimer l\'OU "{{name}}" ? Cette action est irréversible.',
    ouDescription: 'Description',
    ouAdminUser: 'Admin OU (AAD User ID)',
    ouType: 'Type',
    ouGdpr: 'RGPD',
    ouAzureGroupId: 'ID de groupe Azure AD',
    ouAzureGroupIdHint: 'Reliez cette OU à son groupe Azure AD réel pour l\'arborescence hiérarchique. Laissez vide si non encore provisionné.',
    ouAzureGroupIdSelectPlaceholder: '— Sélectionnez un groupe racine Azure AD —',
    ouAzureGroupIdLoading: 'Chargement des groupes Azure AD…',
    ouAzureGroupIdRootsError: 'Impossible de charger la liste des groupes Azure AD. Vous pouvez saisir l\'ID manuellement.',
    ouAzureGroupIdCurrentUnknown: 'Groupe actuellement lié (absent de la liste)',
    ouAzureGroupIdManualToggle: 'Saisir l\'ID manuellement',
    ouAzureGroupIdListToggle: 'Choisir dans la liste',
    ouActivate: 'Activer l\'OU',
    ouDeactivate: 'Désactiver l\'OU',
    ouActivateCascadeTitle: 'Activer l\'OU et ses dépendances',
    ouActivateCascadeConfirm: 'Activer « {{name}} » activera également toute sa descendance (unités dépendantes concernées : {{units}}). Vous pourrez les désactiver individuellement ensuite.',
    ouDeactivateCascadeTitle: 'Désactiver l\'OU et ses dépendances',
    ouDeactivateCascadeConfirm: 'Désactiver « {{name}} » désactivera également toute sa descendance (unités dépendantes concernées : {{units}}).',
    ouActiveSaveError: 'Impossible d\'enregistrer le changement de statut de l\'OU. Veuillez réessayer.',
    ouExpand: 'Développer',
    ouLockedHint: "Votre unité organisationnelle : elle ne peut pas être retirée du périmètre.",
    ouCollapse: 'Réduire',
    ouSelectPlaceholder: 'Sélectionner une OU…',
    ouSearchPlaceholder: 'Rechercher une OU…',
    ouSearchNoResults: 'Aucun résultat.',
    ouInactiveHint: 'OU inactive : ne peut pas être choisie comme nouveau périmètre.',
    ouSelectAllInLevel: 'Tout sélectionner',
    ouBackToLevels: 'Retour au niveau précédent',
    ouErrorName: 'Le nom de l\'OU est obligatoire',
    ouTimezone: 'Fuseau Horaire',
    ouTimezoneSelect: 'Sélectionner le fuseau horaire',
    ouErrorTimezone: 'Le fuseau horaire est obligatoire',
    colFundamental: 'Fondamental',
    colCondition: 'Condition',
    placeholderActions: "Actions — Plans d'action post-enquête",
    placeholderCatalog: 'Catalogue de Fondamentaux — Bibliothèque de comportements évaluables',
    placeholderAnalytics: "Tableau de bord analytique unifié — Voir la vue Exécutif pour le détail complet",
    activeUsersLabel: 'Collaborateurs actifs',
    avgCulturalScore: 'Score culturel moyen',
    participationRateLabel: 'Taux de participation',
    omissionRateLabel: "Taux d'omission",
    thisMonth: 'ce mois',
    rulesTitle: 'Règles Métier',
    restoreDefaults: 'Restaurer les défauts',
    restoreDefaultsTitle: 'Restaurer la configuration par défaut',
    restoreDefaultsDesc: 'Toutes les valeurs des règles métier seront réinitialisées à leur configuration d\'origine. Cette action est irréversible.',
    restoreDefaultsConfirm: 'Oui, restaurer',
    rn001Title: 'Critères de Réunion',
    rn001Subtitle: 'Définit la durée des réunions qui déclenchent une enquête',
    rn002Title: "Règles d'Exclusion",
    rn002Subtitle: 'Scénarios où les enquêtes ne sont PAS déclenchées',
    rn004Title: 'Limites par Utilisateur',
    rn004Subtitle: "Contrôle le nombre d'enquêtes reçues par chaque personne",
    rn005Title: "Limite Quotidienne d'Enquêtes",
    rn005Subtitle: "Nombre maximum d'enquêtes qu'un utilisateur peut recevoir par jour",
    fieldMinSessionDuration: 'Durée minimale de session',
    fieldMaxSessionDuration: 'Durée maximale de session',
    fieldMinParticipants: 'Minimum de participants',
    fieldMaxParticipants: 'Maximum de participants',
    fieldExclRecurring: 'Exclure les réunions récurrentes',
    fieldExclRecurringSub: 'Ne pas appliquer aux réunions hebdomadaires, dailies, etc.',
    fieldExclWorkHours: 'Exclure hors heures de travail',
    fieldExclWorkHoursSub: "Appliquer uniquement dans les horaires configurés par UO",
    fieldMaxSurveysWeek: 'Maximum d\'enquêtes par semaine',
    fieldMaxParticipantsPerSurvey: 'Maximum de participants à évaluer par enquête',
    fieldMinInterval: 'Intervalle minimum entre enquêtes',
    fieldMaxSurveysDay: "Maximum d'enquêtes par jour par utilisateur",
    rn005Info: "Si un utilisateur a déjà reçu le maximum d'enquêtes dans la journée, les suivantes sont reportées au prochain jour ouvrable en respectant l'ordre de priorité configuré.",
    suffixMinutes: 'minutes',
    suffixUsers: 'utilisateurs',
    suffixSurveysWeek: 'enquêtes/semaine',
    suffixPersons: 'personnes',
    suffixHours: 'heures',
    suffixSurveysDay: 'enquêtes / jour',
    customizableByOU: 'Personnalisable par UO',
    cancelChanges: 'Annuler les modifications',
    saveConfig: 'Enregistrer la configuration',
    rulesConfig: 'Configuration',
    rulesStatus: 'Statut',
    rulesCustom: 'Personnalisé',
    rulesSave: 'Enregistrer',
    rulesCancel: 'Annuler',
    rulesSchedule: 'Horaire',
    rulesInheritsGlobal: '↑ Hérite global',
    rulesInherited: 'Hérité',
    rulesGlobal: 'Global',
    rulesPersonalize: 'Personnaliser',
    tplCatAll: 'Tous',
    tplCatGeneral: 'Général',
    tplCatCustom: 'Personnalisée',
    usersTitle: 'Gestion des Utilisateurs',
    searchUser: 'Rechercher un utilisateur...',
    newUser: 'Nouvel utilisateur',
    notificationsTitle: 'Paramètres de Notifications',
    notifOmitirTitle: 'Notification "IGNORER"',
    notifyAfter: 'Notifier après',
    consecutiveOmissions: '"IGNORER" consécutifs',
    notifyTo: 'Notifier :',
    notifyUser: 'Utilisateur',
    notifyDirectManager: 'Manager direct',
    notifyAdminOU: 'Administrateur UO',
    messageForUser: "Message pour l'utilisateur :",
    availableVarsOmitir: 'Variables disponibles : {nombre}, {count}, {fecha}, {manager}',
    europaOmissionsTitle: 'Omissions Europe (BU)',
    manualOnlyGDPR: 'Manuel uniquement — RGPD',
    gdprWarning: "En raison des réglementations légales (RGPD), les e-mails d'omission pour l'Europe ne sont jamais envoyés automatiquement. L'administrateur doit les rédiger, les réviser et les envoyer manuellement.",
    emailTemplateEmployee: 'Modèle d\'e-mail — employé Europe :',
    reviewBeforeSending: 'Réviser et personnaliser avant chaque envoi.',
    generalNotificationsTitle: 'Notifications Générales',
    notifMessageLabel: 'Message de notification :',
    notifMessagePlaceholder: 'Rédigez le message que vous souhaitez envoyer aux collaborateurs...',
    notifAudienceLabel: 'Audience :',
    notifAudienceGlobal: 'Global (excl. Europe)',
    sendNotification: 'Envoyer la notification',
    availableVarsGeneral: 'Variables disponibles : {nombre}, {ou}, {fecha}',
    saveChanges: 'Enregistrer les modifications',
    saveTemplates: 'Enregistrer les modèles',
    analyticsComingSoon: 'Tableau de bord Analytics — en développement. Consultez la vue Exécutif pour les détails.',
    colType: 'Type',
    tplCategory: 'Catégorie',
    tplQuestions: 'questions',
    tplUse: 'Utiliser',
    tplDeleteTitle: 'Supprimer le modèle',
    tplDeleteDesc: 'Supprimer "{{name}}" ? Cette action est irréversible.',
    tipDeleteTitle: 'Supprimer le conseil',
    tipDeleteDesc: 'Supprimer "{{name}}" ? Cette action est irréversible.',
    tipEditTitle: 'Modifier le conseil',
    tipAddTitle: 'Ajouter un conseil',
    tipFormFundamental: 'Fondamental',
    tipFormSelectFundamental: 'Sélectionnez un fondamental…',
    tipFormDailyHabit: 'Daily Habit lié',
    tipFormSelectDailyHabit: 'Sélectionnez un Daily Habit…',
    tipFormOperator: 'Opérateur',
    tipFormThreshold: 'Seuil %',
    tipFormMax: 'Max %',
    tipFormType: 'Type de conseil',
    tipFormName: 'Nom du conseil',
    tipFormNamePlaceholder: 'Ex. Apprentissage remarquable',
    tipFormText: 'Texte du conseil',
    tipFormTextPlaceholder: 'Message que le collaborateur verra…',
    tipFormActivationRule: 'Condition de résultat',
    tipFormActive: 'Actif',
    tipFormPreview: 'Aperçu',
    tipRangeMin: 'Limite minimum',
    tipRangeMax: 'Limite maximum',
    tipHintCondition: 'Score moyen du fondamental (0–100). Ex : de 0 à 40 active le tip sur des résultats faibles.',
    tipHintBehavior: 'Comportement spécifique auquel ce tip s\'applique.',
    tipFieldObserved: 'Texte observé',
    tipTagGreen: 'boîte verte claire',
    tipTagDark: 'boîte sombre',
    tipTagBlue: 'boîte Niveau Suivant',
    tipHintObserved: 'Ce que les collègues observent le plus. Apparaît en italique dans le panneau de réalisations.',
    tipFieldGrowthSuggestion: 'Suggestion de Croissance',
    tipHintGrowthSuggestion: 'Suggestion actionnable qui apparaît avec la reconnaissance.',
    tipFieldLevelName: 'Nom du niveau',
    tipLevelNamePlaceholder: 'Ex. Élan Nécessaire, En Construction…',
    tipCrecerPairedPlaceholder: 'Ex. Mentionnez le consommateur : Dans votre prochaine décision, demandez…',
    tipTranslations: 'Traductions',
    tipAddLang: '+ Ajouter :',
    tipPreviewContext: 'Voici comment cela apparaîtra sur le tableau de bord du collaborateur :',
    tipSave: 'Enregistrer le conseil',
    tipSaveError: 'Pour enregistrer, complétez les champs suivants :',
    colContent: 'Contenu',
    colActive: 'Actif',
    opGte: 'supérieur ou égal',
    opLte: 'inférieur ou égal',
    opGt: 'supérieur à',
    opLt: 'inférieur à',
    opBetween: 'Entre (plage)',
    actionEditTitle: 'Modifier l\'action',
    actionNewTitle: 'Nouvelle action',
    actionFormTitle: 'Titre de l\'action',
    actionFormTitlePlaceholder: 'Ex. Proposez une action concrète',
    actionFormDescription: 'Description complète',
    actionFormDescPlaceholder: 'Description de l\'action…',
    actionActivationRule: 'Règle d\'activation',
    actionActivationRuleHint: 'Score moyen du fondamental (1–4). Définit la plage qui active cette action.',
    actionRuleMin: 'Seuil minimum',
    actionRuleMax: 'Seuil maximum',
    actionRangeLabel: 'Plage',
    actionNextLevelText: 'Texte "Niveau Suivant"',
    actionNextLevelHint: 'Affiché dans la boîte bleue de la carte.',
    actionNextLevelPlaceholder: 'Ex. Pour atteindre le niveau suivant, concentrez-vous sur…',
    actionPreview: 'Aperçu',
    actionPreviewEmpty: 'Remplissez le formulaire pour voir l\'aperçu',
    actionTranslations: 'Traductions',
    actionTransComplete: 'Traduction complète',
    actionTransMissing: 'Traduction incomplète',
    actionPreviewContext: 'Ainsi apparaîtra dans le tableau de bord du collaborateur :',
    actionFormDescHint: 'Affiché à l\'ouverture de l\'action.',
    actionSave: 'Enregistrer l\'action',
    actionSaveError: 'Pour enregistrer, complétez les champs suivants :',
    actionDeleteTitle: 'Supprimer l\'action',
    actionDeleteDesc: 'Supprimer "{{name}}" ? Cette action est irréversible.',
    fundEditTitle: 'Modifier le Fondamental',
    fundNewTitle: 'Nouveau Fondamental',
    fundFormFullName: 'Nom complet',
    fundFormFullNamePlaceholder: 'Ex. Mindset & Behavior - Learner',
    fundFormShortName: 'Nom court',
    fundFormShortNamePlaceholder: 'Ex. Learner',
    fundFormDescription: 'Description',
    fundFormDescriptionPlaceholder: 'Brève description de ce fondamental...',
    fundFormIcon: 'Icône',
    fundFormColor: 'Couleur',
    fundFormUrl: 'URL de référence',
    fundFormMicrositeUrl: 'URL du microsite',
    fundFormUrlPlaceholder: 'https://...',
    fundFormLanguage: 'Langue',
    fundFormAllLangsRequired: 'Remplissez le nom complet, le nom court et la description dans les 7 langues pour pouvoir enregistrer.',
    behEditTitle: 'Modifier le Daily Habit',
    behNewTitle: 'Nouveau Daily Habit',
    behFormName: 'Nom du Daily Habit',
    behFormNamePlaceholder: 'Ex. Humility & Openness',
    behFormAllLangsRequired: 'Remplissez le nom dans les 7 langues pour pouvoir enregistrer.',
    behFormFundamental: 'Fondamental lié',
    behFormIntro: 'Intro / contexte d\'évaluation',
    behFormIntroPlaceholder: 'Ex. Dans cette réunion, cette personne…',
    behFormRoles: 'Rôles applicables',
    behFormRolesHint: 'À qui ce Daily Habit s\'applique-t-il ?',
    fundDeleteTitle: 'Supprimer le fondamental',
    fundDeleteDesc: 'Supprimer "{{name}}" ? Cette action est irréversible.',
    behDeleteTitle: 'Supprimer le Daily Habit',
    behDeleteDesc: 'Supprimer "{{name}}" ? Cette action est irréversible.',
    imageUploadSelect: 'Téléverser une image',
    imageUploadChange: "Changer l'image",
    imageUploadInvalidFormat: 'Format non pris en charge. Utilisez PNG, JPG, WEBP ou SVG.',
    imageUploadTooLarge: 'Le fichier dépasse la taille maximale autorisée (2 Mo).',
    catalogSaveError: 'Impossible d\'enregistrer les modifications du catalogue. Veuillez réessayer.',
    catalogImageUploadError: 'Impossible de téléverser l\'image. Veuillez réessayer.',
    fundFormImage: 'Image',
    attNewTitle: 'Nouvelle Attitude et Comportement',
    attEditTitle: "Modifier l'Attitude et Comportement",
    attFormName: "Nom de l'Attitude et Comportement",
    attFormNamePlaceholder: 'Ex. Collaboration active',
    attFormDescription: "Description de l'Attitude et Comportement",
    attFormDescriptionPlaceholder: 'Brève description de cette attitude et comportement...',
    attFormAllLangsRequired: 'Renseignez le nom dans les 7 langues pour enregistrer.',
    attFormImage: 'Image',
    attDeleteTitle: "Supprimer l'Attitude et Comportement",
    attDeleteDesc: 'Supprimer "{{name}}" ? Ses Daily Habits seront également désactivés.',
    catalogAttitudesLabel: 'attitudes et comportements',
    catalogSelectAttitude: 'Sélectionnez une Attitude et Comportement dans la liste',
    catalogBackToFundamentals: 'Retour aux Fundamentals',
    catalogBackToAttitudes: 'Retour aux Attitudes et Comportements',
    catalogGroupWithAttitudes: 'Regrouper sous Attitudes et Comportements',
    catalogNoFundamentals: 'Aucun fondamental',
    madurezEditTitle: 'Modifier les niveaux de Maturité Culturelle',
    madurezFrameworkTitle: 'Maturité Culturelle — Cadre de niveaux',
    nivelesAdopcionTitle: "Étapes d'adoption d'un Daily Habit — Cadre de niveaux",
    nivelesAdopcionEditTitle: "Modifier les étapes d'adoption d'un Daily Habit",
    madurezLabelPlaceholder: 'Étiquette',
    audienceGlobal: 'Global (excl. Europe)',
    audienceMexico: 'Mexique',
    audienceLATAM: 'LATAM',
    audienceUSA: 'États-Unis',
    audienceFOSE: 'FOSE',
    rn000Title: 'Désactiver l\'App par UO',
    rn000Subtitle: 'Désactive complètement Sigma Pulse pour une ou plusieurs unités organisationnelles.',
    rn000Warning: 'En désactivant une UO, tous ses collaborateurs cessent immédiatement de recevoir des enquêtes. Les données historiques sont conservées.',
    rn003Title: 'Horaires de travail par UO',
    rn003Subtitle: 'Plages horaires d\'application des enquêtes (heure locale)',
    rn003GlobalDefault: 'Horaires globaux par défaut',
    rn003GlobalNote: 'S\'applique à toutes les UO sans horaires personnalisés.',
    rn003TimeConnector: 'à',
    ouActive: 'Active',
    ouDisabled: 'Désactivée',
    rn002KwLabel: 'Exclure seulement si le nom contient :',
    rn002KwHint: '(vide = toutes les récurrentes)',
    rn002KwPlaceholder: 'Ajouter un mot-clé...',
    usersAdminTitle: 'Gestion des Administrateurs',
    addAdmin: 'Ajouter un Administrateur',
    editAdmin: 'Modifier l\'Administrateur',
    newAdmin: 'Nouvel Administrateur',
    adminEmail: 'Adresse e-mail',
    adminUser: 'Utilisateur',
    userSearchPlaceholder: 'Rechercher par nom ou e-mail…',
    userSearchNoResults: 'Aucun utilisateur trouvé',
    userSearchError: 'Erreur lors de la recherche d’utilisateurs',
    adminRole: 'Rôle',
    adminRolePlaceholder: 'Sélectionnez un rôle...',
    adminOU: 'Unité Opérationnelle (UO)',
    adminOUPlaceholder: 'Sélectionnez une UO...',
    adminOUAll: 'Toutes (accès complet à l\'UO)',
    adminBU: 'Unité d\'affaires (BU) — optionnel',
    adminBUPlaceholder: 'Toute l\'UO (sans restriction)',
    adminBUHint: 'Si aucune BU n\'est sélectionnée, l\'admin gère toute l\'UO.',
    colUser: 'Utilisateur',
    colAlcance: 'Portée',
    colPermisos: 'Permissions',
    colEstado: 'Statut',
    permGlobalTitle: 'Les Admins UO/BU peuvent créer des enquêtes',
    permGlobalDesc: 'Quand actif, tous les Admins UO/BU peuvent créer et envoyer des enquêtes.',
    permEnabled: 'Activé',
    permDisabled: 'Désactivé',
    permCreateSurveys: 'Créer des enquêtes',
    permViewAnalytics: 'Voir Analytics',
    permManageUsers: 'Gérer les utilisateurs',
    permApproveSurveys: 'Approuver les enquêtes',
    permCatalogFund: 'Catalogue Fondamentaux',
    permCatalogOus: 'Catalogue OUs',
    // 2026-08-08 — réorganisation du menu Administration
    administratorsTab: 'Gestion des administrateurs',
    catalogFundTab: 'Catalogue Fondamentaux',
    catalogOusTab: 'Catalogue OUs',
    rolesPulsoTab: 'Configurer les rôles et permissions',
    rolesPulsoTitle: 'Configurer les rôles et permissions',
    rolesPulsoAllScopes: 'Tous',
    rolesPulsoAlreadyNote: 'Cette personne est déjà administratrice Pulso — modifiez ses données ci-dessous.',
    rolesPulsoCannotEditGlobal: "Cette personne a déjà le rôle Admin Général. Ce rôle ne se gère pas depuis ici.",
    administratorsTitle: 'Gestion des administrateurs',
    administratorsDesc: 'Ajouter ou retirer des administrateurs globaux du système.',
    addGlobalAdmin: 'Ajouter un administrateur',
    newGlobalAdmin: 'Nouvel administrateur global',
    adminGlobalRemoveTitle: 'Retirer l\'administrateur global',
    adminGlobalRemoveDesc: 'Retirer « {{name}} » en tant qu\'administrateur global ? Son compte reste un collaborateur standard.',
    userDeleteTitle: 'Retirer l\'administrateur',
    userDeleteDesc: 'Retirer "{{name}}" en tant qu\'administrateur ? Son compte reste actif en tant que collaborateur standard, sans permissions d\'administration.',
    userCreated: 'Utilisateur créé avec succès.',
    userSaveError: 'Impossible d’enregistrer les modifications. Veuillez réessayer.',
    userSaveForbidden: "Vous n'avez pas la permission de modifier cet administrateur. Seul un Admin Général le peut.",
    userCreateErrorNotInAd: 'Impossible de créer l’utilisateur : l’e-mail n’existe pas dans Azure AD.',
    userDeleteError: 'Impossible de retirer le rôle d’administrateur. Veuillez réessayer.',
    noUsersFound: 'Aucun résultat',
    adminCount: 'administrateurs',
    filterEmailPlaceholder: 'Rechercher par e-mail...',
    filterRoleLabel: 'Filtrer par rôle',
    filterRoleAll: 'Tous les rôles',
    filterClear: 'Effacer les filtres',
    rolesMultiHint: 'Vous pouvez sélectionner plusieurs rôles en maintenant la touche Ctrl (Cmd sur Mac) enfoncée.',
    modulesTitle: 'Modules',
    modulesHint: 'Contrôle l\'accès aux modules du produit, indépendamment du rôle attribué.',
    modulePulso: 'Pulso',
    moduleBrillamos: 'Reconnaissance',
    permAllGranted: 'Toutes accordées',
    userNotManageable: 'Vous ne pouvez pas gérer cet utilisateur',
    messageForManager: 'Message pour le manager :',
    emailTemplateManager: 'Modèle d\'e-mail — manager Europa :',
    notifOUPersonalization: 'Personnalisation par UO',
    addOUPersonalization: 'Ajouter une personnalisation',
    europaNoAutoSend: 'Ces e-mails ne sont pas envoyés automatiquement. Ils doivent être envoyés manuellement.',
    europaActivateTitle: 'Activer les notifications Europa ?',
    europaActivateDesc: 'Les notifications d\'omission pour l\'Europe sont soumises à des réglementations RGPD strictes. En activant cette section, vous confirmez avoir l\'autorisation du responsable de la confidentialité de l\'UO Europa et que les e-mails seront envoyés manuellement avec une révision préalable.',
    europaActivateConfirm: 'Oui, activer avec responsabilité',
    includeEuropa: 'Inclure Europa (BU)',
    includeEuropaHint: 'nécessite une révision RGPD avant envoi',
    europaSectionDisabled: 'Section désactivée — activez le commutateur pour configurer',
    ouPersonalizedSingular: 'OU personnalisée',
    ouPersonalizedPlural: 'OUs personnalisées',
    notifCustomUserMsgPlaceholder: 'Message personnalisé pour l\'utilisateur…',
    notifCustomMgrMsgPlaceholder: 'Message personnalisé pour le manager…',
    kwRemove: 'Supprimer',
    kwAdd: 'Ajouter',
    permissions: 'Permissions',
    rules: 'Règles métier',
    catalog: 'Catalogue',
    createUser: 'Créer un utilisateur',
    editUser: 'Modifier un utilisateur',
    deleteUser: 'Supprimer un utilisateur',
    roles: 'Rôle',
    organizationalUnit: 'Unité Organisationnelle',
    minDuration: 'Durée min (min)',
    maxDuration: 'Durée max (min)',
    minParticipants: 'Participants min',
    maxPerDay: 'Évaluations max par jour',
    maxPerWeek: 'Évaluations max par semaine',
    omissionThreshold: "Seuil d'omissions",
    columns: 'Colonnes',
    colPickerTitle: 'Colonnes visibles',
    colPickerReset: 'Réinitialiser',
    pagerRowsPerPage: 'Lignes par page',
    pagerOf: 'sur',
    confirmMoveToTrash: 'Déplacer vers la corbeille?',
    confirmMoveToTrashMsg: "L'enquête sera déplacée vers la corbeille et supprimée définitivement après 30 jours. Vous pouvez la restaurer avant cette date.",
    confirmMoveBtn: 'Déplacer vers la corbeille',
    confirmDeleteForeverTitle: 'Supprimer définitivement?',
    confirmDeleteForeverMsg: "Cette action est irréversible. L'enquête et toutes ses données seront supprimées pour toujours.",
    confirmDeleteForeverBtn: 'Supprimer définitivement',
    trashTitle: "Corbeille d'enquêtes",
    trashSubtitle: 'Les enquêtes sont supprimées définitivement après 30 jours',
    trashEmpty: 'La corbeille est vide',
    trashRestore: 'Restaurer',
    trashDaysLeft: 'jours restants',
    colSurvey: 'Enquête',
    trashResponses: 'rép.',
    trashTimeLeft: 'Temps restant',
    trashDeletedBy: 'Supprimé par',
    trashDeletedAt: 'Date de suppression',
    trashDays: 'jours',
    trashExpiresTODAY: 'Expire aujourd\'hui',
    filterAll: 'Tous',
    filterSearchName: 'Rechercher nom…',
    filterSearchCreator: 'Rechercher créateur…',
    filterFrom: 'Du',
    filterTo: 'Au',
    filterClearDates: 'Effacer les dates',
    pauseSurvey: 'Mettre en pause',
    activateSurvey: 'Activer',
    builderNewTitle: 'Nouvelle Enquête',
    builderEditTitle: 'Modifier Enquête',
    builderNewTemplateTitle: 'Nouveau Modèle',
    builderEditTemplateTitle: 'Modifier Modèle',
    builderBackToSurveys: 'Retour aux enquêtes',
    builderSaveDraft: 'Enregistrer brouillon',
    builderPublish: "Publier l'enquête",
    builderStep1: 'Informations de base',
    builderStep2: 'Audience et fréquence',
    builderStep3: 'Questions',
    builderStep4: 'Révision',
    builderPreview: 'Aperçu',
    builderName: "Nom de l'enquête",
    builderNamePlaceholder: 'Ex: Évaluation post-réunion Q2',
    builderDescription: 'Description',
    builderDescriptionPlaceholder: "Décrivez l'objectif de cette enquête…",
    builderApproach: 'Approche',
    builderApproachIndividual: 'Individuel',
    builderApproachCollective: 'Collectif',
    builderAnonymous: 'Évaluation anonyme',
    builderAnonymousSub: 'Les évalués ne sauront pas qui les a évalués',
    dayMon: 'Lundi', dayTue: 'Mardi', dayWed: 'Mercredi', dayThu: 'Jeudi',
    dayFri: 'Vendredi', daySat: 'Samedi', daySun: 'Dimanche',
    dayMonShort: 'Lun', dayTueShort: 'Mar', dayWedShort: 'Mer', dayThuShort: 'Jeu',
    dayFriShort: 'Ven', daySatShort: 'Sam', daySunShort: 'Dim',
    dayLetterMon: 'L', dayLetterTue: 'M', dayLetterWed: 'M', dayLetterThu: 'J',
    dayLetterFri: 'V', dayLetterSat: 'S', dayLetterSun: 'D',
    activeDaysAll: 'Le sondage sera actif toute la semaine',
    activeDaysPrefix: 'Le sondage sera actif le :',
    activeDaysNone: 'Aucun jour sélectionné',
    workdays: 'Jours ouvrables',
    builderExitTitle: "Quitter l'éditeur ?",
    builderExitDesc: "Les modifications non enregistrées seront perdues si vous quittez maintenant.",
    builderExitCancel: 'Continuer à modifier',
    builderExitConfirm: 'Oui, quitter',
    builderValidationTitle: 'Champs obligatoires',
    builderValidationDesc: 'Veuillez compléter les champs suivants avant de continuer :',
    builderValidationClose: 'Compris',
    builderValidationName: 'Identifiant interne',
    builderValidationSurveyType: 'Type d\'enquête',
    builderValidationStartDate: 'Date de début',
    builderValidationEndDate: 'Date de fin',
    builderValidationDateRange: 'La date de fin ne peut pas être antérieure à la date de début',
    builderValidationActiveDays: 'Au moins un jour d\'activation',
    builderValidationStartDatePast: 'La date de début est déjà passée ; l\'enquête ne serait jamais publiée',
    builderValidationEndDatePast: 'La date de fin est déjà passée ; l\'enquête ne serait jamais publiée',
    builderValidationMeetingId: 'Saisissez l\'ID du Meeting',
    builderValidationPeople: 'Sélectionnez au moins une personne',
    builderValidationOU: 'Sélectionnez au moins une UO',
    builderValidationNoQuestions: 'Vous devez ajouter au moins une question pour continuer. Il est impossible de créer des enquêtes sans questions.',
    builderValidationMinParticipants: 'Le nombre minimum de participants doit être au moins 1',
    builderValidationMaxParticipants: 'Le nombre maximum de participants doit être au moins 1',
    builderValidationParticipantsRange: 'Le minimum de participants ne peut pas être supérieur au maximum',
    builderValidationTranslations: 'Traductions incomplètes',
    // Builder new keys
    builderCloseEditor: "Fermer l'éditeur",
    builderPrevious: 'Précédent',
    builderNext: 'Suivant',
    builderSaveTemplate: 'Enregistrer comme modèle',
    builderInternalId: 'Identifiant interne',
    builderInternalIdHint: 'Visible uniquement par les administrateurs — les employés ne voient pas ce nom en répondant',
    builderSurveyTypeStar: "Type d'enquête",
    builderTypeGeneral: 'Générale',
    builderTypeGeneralDesc: 'Régie par des règles métier. Déclenchée automatiquement après les réunions.',
    builderTypePersonalized: 'Personnalisée',
    builderTypePersonalizedDesc: 'Liée à une session Teams spécifique par Meeting ID.',
    builderPeriod: "Période de l'enquête",
    builderStartLabel: 'Début',
    builderEndLabel: 'Fin',
    builderPeriodHint: "L'enquête sera activée à la date de début et désactivée automatiquement à la fin",
    builderActiveDaysLabel: "Jours d'activation",
    builderActiveDaysLockedHint: "Le jour est défini automatiquement car la plage de dates ne couvre qu'un seul jour",
    builderCustomTag: 'Personnalisé',
    builderAudienceSectionTitle: 'Audience',
    builderWhoApplies: 'À qui cette enquête s\'applique-t-elle ?',
    builderSelectOneOrMoreOUs: 'Sélectionnez une ou plusieurs UO',
    builderGlobal: 'Global',
    builderGlobalDesc: 'Toutes les UO et BU',
    builderExcludesEurope: 'exclut l\'Europe',
    builderGlobalAdminOUAccess: 'Administrateur Global — vous avez accès à toutes les UO du système.',
    builderLegalRegulation: 'Réglementation légale — toujours un champ séparé',
    builderEurope: 'Europe (BU)',
    builderGDPRTag: 'RGPD — Réglementation légale',
    builderEuropeExcludedNote: "L'Europe n'est jamais incluse dans les campagnes Globales ni multi-UO pour des raisons de conformité légale.",
    builderEuropaAuthNote: "N'oubliez pas d'obtenir l'autorisation de l'UO Europe avant d'envoyer des enquêtes à cette région.",
    builderAudienceCustomTitle: 'Destinataires',
    builderAudienceCustomSubtitle: 'Définissez qui recevra cette enquête personnalisée.',
    builderRecipientsLabel: 'Destinataires',
    builderByMeetingId: 'Par Meeting ID',
    builderByPeople: 'Personnes spécifiques',
    builderByOU: 'Par organigramme (UO)',
    audienceTypeMeeting: 'Meeting',
    audienceTypePeople: 'Personnes',
    audienceTypeOU: 'UO',
    builderMeetingIdHint: 'Sera appliqué à tous les participants de cette session Teams',
    builderSelectPeople: 'Sélectionnez des personnes dans la liste',
    builderAllOUs: 'Toutes les UO',
    builderAllAvailableAdded: 'Toutes les personnes disponibles ont déjà été ajoutées',
    builderSearchPeoplePlaceholder: 'Rechercher une personne par nom…',
    builderLoadingPeople: 'Chargement des personnes…',
    builderErrorLoadingPeople: 'Impossible de charger la liste des personnes. Réessayez.',
    builderPersonSelected: 'personne sélectionnée',
    builderPeopleSelected: 'personnes sélectionnées',
    builderSelectOU: 'Sélectionnez une UO...',
    builderSelectOUForTeam: 'Sélectionnez une UO pour voir ses collaborateurs',
    builderQuestionsTitle: 'Questions',
    builderEuropaQuestionsNote: 'Mode Europe : enquête libre, sans lien avec les Fondamentaux. Questions sur la réunion uniquement.',
    builderQuestionsApplyToAll: 'Chaque question s\'applique à chaque participant à la réunion.',
    builderFilterAll: 'Tous',
    builderNoQuestions: 'Pas encore de questions',
    builderNoQuestionsHint: 'Cliquez sur "+ Ajouter une question" pour commencer',
    builderNoQuestionsOfType: 'Aucune question de ce type',
    builderAddQuestion: '+ Ajouter une question',
    builderQuestionLabel: 'Question',
    builderDeleteQuestion: 'Supprimer',
    builderApproachLabel: 'Approche',
    builderIndividualSub: 'Évalue chaque participant',
    builderCollectiveSub: 'Pour la session en général',
    builderPresentationMode: 'Mode de présentation',
    builderMatrix: 'Matrice Générale',
    builderMatrixSub: 'Question sur la réunion ou le sujet général',
    builderIndividualCard: 'Individuel',
    builderIndividualCardSub: 'Une fiche par personne',
    builderTypeLabel: 'Type',
    builderFundamentalLabel: 'Fondamental',
    builderSelectFundamental: 'Sélectionnez un Fondamental...',
    builderDailyHabitLabel: 'Habitude quotidienne',
    builderSelectDailyHabit: 'Sélectionnez une habitude quotidienne...',
    builderQuestionText: 'Texte de la question',
    builderQuestionTextPlaceholder: 'Rédigez la question ici',
    builderIconLabel: 'Icône',
    builderOptional: '(optionnel)',
    builderChangeIcon: 'Modifier',
    builderSelectIconBtn: 'Sélectionner une icône',
    builderOptionsLabel: 'Options (max. 4 + "Non observable")',
    builderNoObservable: 'Non observable',
    builderRemoveNoObs: 'Retirer Non observable',
    builderAddNoObs: 'Ajouter "Non observable"',
    builderAddOption: 'Ajouter une option',
    builderMaxOptions: 'Maximum de 4 options atteint',
    builderNPSInfo: 'NPS : échelle de 0 à 10. Question libre, non attribuée aux participants.',
    builderOpenInfo: 'Espace libre pour que l\'évaluateur rédige sa réponse.',
    builderCampaignWeight: 'Poids de campagne',
    builderAdminGlobalOnly: 'Admin Général uniquement',
    builderCampaignWeightSub: 'Plus le poids est élevé = plus la priorité est haute lorsque plusieurs enquêtes sont actives. Seul l\'Admin Général peut le modifier.',
    builderWeightBase: 'Poids de base (1–10)',
    builderWeightVeryLow: 'Très faible',
    builderWeightLow: 'Faible',
    builderWeightMedium: 'Moyen',
    builderWeightHigh: 'Élevé',
    builderWeightVeryHigh: 'Très élevé',
    builderBoostUrgent: 'Boost urgent',
    builderBoostUrgentSub: 'Élève temporairement cette enquête au-dessus de toutes les autres',
    builderBoostDays: 'jours',
    builderBoostActiveDays: 'jour',
    builderBoostActiveMsg: 'Boost actif — cette enquête aura la priorité maximale pendant',
    builderNoBoostMsg: 'Aucun boost actif — priorité selon le poids de base',
    builderParticipantsTitle: 'Participants à évaluer',
    builderParticipantsSub: 'Définissez combien de personnes sont évaluées par enquête. Minimum pour l\'anonymat et maximum pour ne pas surcharger.',
    builderMinParticipantsLabel: 'Nombre minimum de participants',
    builderMinParticipantsHint: 'Min. pour garantir l\'anonymat',
    builderMaxParticipantsLabel: 'Nombre maximum de participants',
    builderMaxParticipantsHint: 'Max. de personnes à évaluer par enquête',
    builderPrivacyTitle: 'Confidentialité et anonymat',
    builderPrivacySub: 'Définissez si les retours seront associés à l\'identité du répondant.',
    builderEnableAnonymity: 'Activer l\'anonymat',
    builderAnonymityDesc: 'Les retours n\'incluront pas le nom d\'utilisateur — seulement la réponse et l\'heure',
    builderTranslationsTitle: 'Traductions',
    builderTranslationsEuropeSub: 'Audience Europe — les 6 langues sont requises. Utilisez le bouton pour activer ou désactiver une langue.',
    builderTranslationsSub: 'La traduction en anglais est requise au minimum. Utilisez le bouton pour activer des langues supplémentaires.',
    builderAutoTranslateNote: 'Les traductions sont générées automatiquement avec Azure Translator. Révisez et ajustez chaque champ si nécessaire.',
    builderLangNotApplicable: 'Non applicable',
    builderLangComplete: 'Terminé',
    builderLangPending: 'En attente',
    builderLangRequired: 'Obligatoire',
    builderLangOptional: 'Optionnel',
    builderAutoTranslateBtn: 'Traduction auto.',
    builderAutoTranslating: 'Traduction en cours…',
    builderAutoTranslateError: "Échec de la traduction automatique. Veuillez réessayer.",
    sessionExpiredError: "Votre session a expiré. Veuillez recharger la page et vous reconnecter.",
    builderSourceLangLabel: "Langue d'origine",
    builderSourceLangHint: "Langue dans laquelle vous rédigez cette question. Les autres langues seront demandées comme traductions dans la section Traductions.",
    builderLangApplies: 'S\'applique',
    builderLangDoesNotApply: 'Ne s\'applique pas',
    builderTrlName: 'Nom :',
    builderTrlDesc: 'Description :',
    builderTrlEmpty: 'vide',
    builderLangDisabled: 'Cette langue est désactivée pour cette enquête.',
    builderReviewTitle: 'Réviser et publier',
    builderReviewTemplateTitle: 'Réviser le modèle',
    builderEuropaPublishNote: 'Mode Europe : campagne indépendante pour RGPD. N\'oubliez pas d\'obtenir l\'autorisation de l\'UO Europe.',
    builderPublishIdLabel: 'Identifiant',
    builderPublishInternal: '(interne)',
    builderPublishTypeLabel: 'Type',
    builderPublishAudienceLabel: 'Audience',
    builderPublishQuestionsLabel: 'Questions',
    builderPublishActiveDaysLabel: 'Jours actifs',
    builderPublishExpirationLabel: 'Expiration',
    builderPublishAnonymityLabel: 'Anonymat',
    builderPublishAnonymousVal: 'Anonyme',
    builderPublishNominalVal: 'Nominale',
    builderCompleteBeforePublish: 'À compléter avant de publier :',
    builderCompleteBeforeSave: 'À compléter avant de sauvegarder :',
    builderReadyToPublish: 'Tout est prêt. Cliquez sur Publier l\'enquête pour l\'activer.',
    builderReadyToSaveTemplate: 'Tout est prêt. Cliquez sur Enregistrer le modèle pour le sauvegarder.',
    builderIconCatalogTitle: 'Catalogue d\'icônes',
    builderSystemIcons: 'Icônes système',
    builderNoIcon: 'Sans icône',
    builderMyCatalog: 'Mon catalogue',
    builderDeleteFromCatalog: 'Supprimer du catalogue',
    builderCatalogEmpty: 'Votre catalogue est vide — téléchargez une icône et enregistrez-la ici',
    builderUploadIcon: 'Télécharger une nouvelle icône',
    builderIconNamePlaceholder: 'Nom de l\'icône (ex. Innovation)',
    builderSelectFile: 'Sélectionner un fichier',
    builderInvalidFormat: 'Format invalide. Utilisez SVG ou PNG avec un fond transparent.',
    builderFileTooLarge: 'Fichier trop volumineux. Maximum 200 Ko.',
    builderCustomIcon: 'Icône personnalisée',
    builderSaveForReuse: 'Enregistrer dans le catalogue pour réutiliser',
    builderUseIcon: 'Utiliser l\'icône',
    builderIconHelp: 'SVG ou PNG, fond transparent, 512×512 px recommandé, max. 200 Ko',
    builderPreviewCompleteStep1: 'Complétez les données de l\'Étape 1 pour voir l\'aperçu',
    builderPreviewClickToEdit: 'Cliquez sur n\'importe quel texte pour le modifier',
    builderPreviewNoQuestions: 'Les questions apparaîtront ici à l\'Étape 3',
    builderPreviewGeneral: 'Générale',
    builderPreviewPersonalized: 'Personnalisée',
    builderPreviewPulsoEspecifica: 'Pouls Spécifique',
    builderPreviewChangeIcon: 'Modifier l\'icône',
    builderPreviewIndividual: 'Individuel',
    builderPreviewCollective: 'Collectif',
    builderPreviewModeIndividual: 'Individuel',
    builderPreviewModeMatrix: 'Matrice Générale',
    builderPreviewMissingTranslation: '(sans traduction)',
    builderPreviewWriteAnswer: 'Rédigez votre réponse ici...',
    builderPreviewNoObs: 'Non observable',
    builderPreviewNA: 'N/A',
    builderNavInfo: 'Info',
    builderNavAudiencia: 'Public',
    builderNavPreguntas: 'Questions',
    builderNavConfig: 'Paramètres',
    builderNavPublicar: 'Publier',
    builderNavGuardar: 'Enregistrer',
    builderInfoTitle: 'Informations de base',
    builderSelectAll: 'Tout sélectionner',
    langEn: 'Anglais',
    langDe: 'Allemand',
    langPt: 'Portugais',
    langFr: 'Français',
    langNl: 'Néerlandais',
    langRo: 'Roumain',
    builderTrlPlaceholderIn: 'en',
    builderTrlPlaceholderOpt: 'Option',
    builderTrlNoText: 'Pas encore de texte',
    // New keys added during refactor
    builderLinkedTo: 'Lié à',
    builderSelectedIcon: 'Sélectionné',
    builderHidePreview: 'Masquer l\'aperçu',
    builderShowPreview: 'Afficher l\'aperçu',
    builderPreviewMorePersons: 'personnes de plus',
    builderPreviewOption1: 'Option 1',
    builderPreviewOption2: 'Option 2',
    builderPreviewViewIn: 'Voir en :',
    builderFromOU: 'de',
    builderWillReceiveSurvey: 'recevront cette enquête',
    builderPersonsCount: 'personnes',
    builderPersonsPlural: 'personnes',
    builderPersonSingular: 'personne',
    builderInternalIdPlaceholder: 'Ex : Fondamentaux T1 2026',
    builderMeetingIdPlaceholder: 'Ex : 19:meeting_abc123@thread.v2',
    builderOptionDefault: 'Option',
    builderRemovePerson: 'Supprimer',
    builderSaveTemplateMock: 'Enregistré comme modèle ✓',
    builderPublishGlobalLabel: 'Global (excl. Europe)',
    builderTypeRating: 'Évaluation (1-4)',
    builderTypeMultiple: 'Choix multiple',
    builderTypeOpen: 'Question ouverte',
    builderTypeBehaviors: 'Comportements',
    builderTypeNPS: 'NPS (1-10)',
    // System tab
    systemTab: 'Système',
    // Monitor tab
    monitorTab: 'Surveillance',
    // Trace tab
    traceTab: 'Traçabilité',
    // Jobs tab
    jobsTab: 'Jobs',
  },
  jobs: {
    title: 'Synchronisation de l’effectif',
    subtitle: 'D’où viennent les utilisateurs et les unités organisationnelles, le catalogue des domaines d’entreprise et l’état de chaque exécution.',
    ouCatalogSync: 'Synchronisation des UO',
    userCatalogSync: 'Synchronisation des utilisateurs',
    statusNeverRun: 'Jamais exécuté',
    statusRunning: 'En cours…',
    statusSuccess: 'Succès',
    statusSkipped: 'Ignoré',
    statusFailed: 'Erreur',
    lastRun: 'Dernière exécution',
    duration: 'Durée',
    triggerScheduled: 'Automatique',
    triggerManual: 'Manuel',
    created: 'Créés',
    updated: 'Mis à jour',
    unchanged: 'Inchangés',
    skipReason: 'Motif',
    errorMessage: 'Erreur',
    nextScheduled: 'Prochaine exécution automatique',
    nextScheduledUnknown: 'Calculée après la première exécution',
    padronTitle: 'Registre',
    padronTotal: 'Fiches au total',
    padronUnclaimed: 'Non réclamées',
    padronLoading: 'Comptage…',
    padronError: 'Impossible de lire le registre.',
    padronHint: "Une fiche non réclamée correspond à une personne du registre qui ne s'est pas encore connectée. Elle n'apparaît pas dans les listes d'administration.",
    identity: "Identité des compteurs",
    identityOk: "Équilibrée",
    identityBad: "NON équilibrée : {{suma}} vs {{recibidas}}",
    drift: "Écart de comptage",
    duplicateEmail: "Courriels dupliqués à la source",
    ouSubidaARaiz: "Fiches remontées à leur unité racine",
    ouHuerfanaResuelta: "Unités inexistantes résolues par région",
    ouHuerfanaSinResolver: "Unités cassées NON résolues",
    managerLinks: "Responsables résolus",
    runNow: 'Exécuter maintenant',
    runningDisabled: 'Déjà en cours',
    viewHistory: 'Voir l\'historique',
    hideHistory: 'Masquer l\'historique',
    historyEmpty: 'Aucune exécution enregistrée pour le moment.',
    historyLoading: 'Chargement de l\'historique…',
    historyError: 'Impossible de charger l\'historique.',
    colDate: 'Date',
    colTrigger: 'Déclencheur',
    colStatus: 'Statut',
    colDuration: 'Durée',
    colDetail: 'Détail',
    triggerError: 'Impossible d\'exécuter le job.',
    triggerConflict: 'Le job est déjà en cours — attendez qu\'il se termine.',
    tabs: {
      users: 'Utilisateurs',
      ous: 'Unités organisationnelles',
      domains: 'Domaines (Excel)',
      sentinels: 'Adresses ignorées (SF)',
    },
    runsTitle: 'Exécutions',
    noJobs: 'Aucune exécution enregistrée pour cette section.',
    sfUserSync: 'Utilisateurs (SuccessFactors)',
    sfOuSync: 'Unités organisationnelles (SuccessFactors)',
    adDomainSweep: 'Balayage des domaines de l’annuaire',
    cuentasBarridas: 'Comptes actifs balayés',
    dominiosObservados: 'Domaines observés',
    dominiosNoDeclarados: 'Observés mais non déclarés',
    dominiosDesaparecidos: 'Déclarés mais plus observés',
    dominiosDesactivados: 'Domaines désactivés',
    sync: {
      title: 'Source de données',
      desc: 'D’où vient l’effectif des collaborateurs.',
      users: 'Source des utilisateurs',
      adOnly: 'Active Directory uniquement',
      adOnlyHint: 'Les collaborateurs du siège viennent de l’AD. SuccessFactors continue de tourner, mais uniquement pour ceux qui n’ont pas de messagerie d’entreprise : ils ne sont pas dans l’AD et n’entreraient jamais autrement.',
      apiOnly: 'SuccessFactors uniquement',
      apiOnlyHint: 'Tout l’effectif vient de SuccessFactors, y compris le siège. L’exécution de l’AD est ignorée.',
      adThenApi: 'AD puis SuccessFactors',
      adThenApiHint: 'Les deux tournent. SuccessFactors ne remplit que ce que l’AD a laissé vide ; la seule exception est le pays, toujours écrit par SuccessFactors.',
      ous: 'Unités organisationnelles',
      ousDesc: 'D’où vient l’arbre des unités organisationnelles.',
      ouSource: 'Source de l’arbre',
      ouAd: 'Active Directory',
      ouApi: 'SuccessFactors',
      sf: 'SuccessFactors',
      sfEnabled: 'Synchronisation activée',
      dryRun: 'Mode simulation',
      dryRunHint: 'L’exécution compte tout et rend les résultats, mais n’écrit AUCUNE modification. C’est le mode recommandé pour la première exécution.',
      sfOn: 'Activée',
      sfOff: 'Désactivée',
      sfDryRun: 'Activée, en simulation',
      sfManagedInUsers: 'Se configure dans l’onglet Utilisateurs : les mêmes interrupteurs régissent les deux exécutions.',
      domains: 'Domaines d’entreprise autorisés — import Excel',
      domainsDesc: 'S’applique UNIQUEMENT à l’import Excel de l’Europe et des États-Unis. Si vous ajoutez un domaine, les personnes du fichier ayant cette adresse se connectent par SSO et ne peuvent plus s’inscrire. Si vous en retirez un, leur adresse est ignorée à l’import et ces personnes devront déclarer la leur en s’inscrivant. Cela n’affecte ni la synchronisation Active Directory ni celle de SuccessFactors.',
      domainsHint: 'Un par ligne, ou séparés par des virgules.',
      domainsCount: '{{n}} domaines',
      domainBadFormat: 'ne ressemble pas à un domaine (vérifiez les espaces, arobases ou chemins)',
      domainDuplicate: 'en doublon : il ne sera enregistré qu’une fois',
      domainsRemoved: 'À RETIRER',
      domainsRemovedWarning: 'Leurs collaborateurs ne se connecteront plus par SSO et pourront s’inscrire avec un mot de passe.',
      domainsAdded: 'À AJOUTER',
      domainsAddedWarning: 'Leurs collaborateurs devront se connecter par SSO et ne pourront plus s’inscrire.',
      domainsReview: 'Vérifier et enregistrer',
      domainsConfirm: 'Confirmer la modification',
      domainsCancel: 'Annuler',
      domainsAllInvalid: 'Aucun domaine valide : impossible d’enregistrer une liste vide.',
      domainsSaved: 'Catalogue de domaines enregistré.',
      saved: 'Configuration enregistrée.',
      loadError: 'Impossible de lire la configuration des sources.',
      updatedBy: 'Dernière modification par',
      errSession: 'Votre session a expiré. Reconnectez-vous et refaites la modification.',
      errForbidden: 'Vous n’avez pas le droit d’enregistrer cette configuration : le rôle AdminGlobal est requis.',
      errValidation: 'La configuration n’a pas passé la validation : {{detalle}}',
      errValidationPlain: 'La configuration n’a pas passé la validation du serveur.',
      errOther: 'Impossible d’enregistrer (erreur {{status}}). Si cela se reproduit, il faut consulter le journal du service.',
      errNetwork: 'Impossible d’enregistrer : aucune réponse du serveur. Vérifiez la connexion et réessayez.',
      sentinels: 'Adresses ignorées de SuccessFactors',
      sentinelsDesc: 'S’applique UNIQUEMENT à la synchronisation SuccessFactors. C’est le texte que la source met dans le champ e-mail quand la personne n’a PAS d’adresse. Ce ne sont pas des adresses : seule la partie avant le @ est comparée, donc « nomail » couvre nomail@n’importe-quel-domaine. Si vous retirez une entrée, ce texte sera enregistré comme une vraie adresse : la personne comptera comme cadre, ne pourra plus s’inscrire, et l’exécution peut échouer pour doublon d’adresse.',
      sentinelsHint: 'Une par ligne. Vous pouvez coller des adresses complètes : seule la partie avant le @ est enregistrée.',
      sentinelsCount: '{{n}} entrées',
      sentinelBadFormat: 'ne ressemble pas à un nom de boîte valide (vérifiez les espaces ou les caractères inhabituels)',
      sentinelNormalized: 'sera enregistré comme « {{valor}} », et couvrira donc ce nom sur N’IMPORTE QUEL domaine',
      sentinelsRemovedWarning: 'Ce texte sera de nouveau enregistré comme une vraie adresse. Si deux personnes le partagent, l’exécution échouera pour doublon d’adresse.',
      sentinelsAddedWarning: 'Toute personne portant ce texte comptera comme « sans adresse » et devra s’inscrire.',
      sentinelsSaved: 'Liste des adresses ignorées enregistrée.',
      sentinelsEmpty: 'La liste ne peut pas rester vide : sans aucune entrée, les adresses factices de la source seraient enregistrées comme de vraies adresses et l’exécution échouerait.',
    },
  },
  monitor: {
    title: 'Moniteur de Pipeline',
    subtitle: 'Audit des événements d\'éligibilité de réunions traités par le moteur de règles.',
    refresh: 'Actualiser',
    lastFetch: 'Dernière mise à jour',
    loading: 'Chargement des événements…',
    timeout: 'Délai d\'attente dépassé',
    unknownError: 'Erreur inconnue',
    empty: 'Aucun événement de pipeline trouvé.',
    eligible: 'Éligible',
    ineligible: 'Inéligible',
    sampled: 'Inclus',
    excluded: 'Exclu',
    samplingApplied: 'Échantillonnage max appliqué',
    noParticipants: 'Aucun participant enregistré.',
    statTotal: 'Événements totaux',
    statEligible: 'Réunions éligibles',
    statAvgSampled: 'Moy. participants échantillonnés',
    statAvgSampledSub: 'Par réunion éligible',
    statSampling: 'Avec échantillonnage max',
    statSamplingSub: 'Plafond de participants appliqué',
    colMeetingId: 'ID Réunion',
    colDate: 'Date',
    colDuration: 'Durée',
    colEvaluated: 'Évalués',
    colEligible: 'Éligibles',
    colSampled: 'Échantillonnés',
    colMaxPax: 'Max',
    colResult: 'Résultat',
    colUserId: 'ID Utilisateur',
    colOu: 'OU',
    colTimezone: 'Fuseau',
    colToday: 'Auj.',
    colWeek: 'Sem.',
    colInterval: 'Intervalle',
    colStatus: 'Statut',
    colReason: 'Raison',
    colSample: 'Envoi',
    instancesTitle: 'Enquêtes assignées',
    instancesBtnTitle: 'Voir les enquêtes de ce participant',
    instancesLoading: 'Chargement des enquêtes…',
    instancesEmpty: 'Aucune instance d\'enquête trouvée pour ce participant dans cette réunion.',
    instancesSurvey: 'Enquête',
    instancesStatus: 'Statut',
    instancesExpires: 'Expire',
    instancesDownload: 'Télécharger JSON',
    instancesClose: 'Fermer',
    sortAsc: 'Trier par ordre croissant',
    sortDesc: 'Trier par ordre décroissant',
    recalculate: 'Recalculer les réponses',
    recalculateTitle: 'Recalculer le nombre de réponses pour toutes les enquêtes',
    recalculateSuccess: 'Recalcul terminé : {{count}} enquête(s) mise(s) à jour.',
    recalculateError: 'Erreur lors du recalcul des réponses.',
    cacheTitle: 'Cache du catalogue des UO',
    cacheLoading: 'Vérification du cache…',
    cacheError: "Impossible d'obtenir l'état du cache des UO.",
    cachePopulated: 'Alimenté',
    cacheNotPopulated: 'Non alimenté',
    cacheOuCount: 'UO en cache',
    cacheLastSynced: 'Dernière synchronisation',
    cacheNeverSynced: 'Jamais synchronisé',
  },
  trace: {
    title: 'Traçabilité du pipeline',
    subtitle: 'Parcours complet d\'une réunion, de la fin de l\'appel à l\'envoi de la notification.',
    filterModeLabel: 'Rechercher par',
    filterModeSubject: 'Nom de la réunion',
    filterModeEmail: 'E-mail',
    filterPlaceholderSubject: 'Ex. : Daily de la plateforme',
    filterPlaceholderEmail: 'Ex. : prenom.nom@sigma.com',
    search: 'Rechercher',
    searching: 'Recherche en cours…',
    clear: 'Effacer',
    initialHint: 'Choisissez un mode de recherche et saisissez un terme pour voir la traçabilité.',
    invalidEmail: 'Saisissez une adresse e-mail valide.',
    requestError: 'Impossible d\'obtenir la traçabilité. Réessayez.',
    retry: 'Réessayer',
    download: 'Télécharger la trace (JSON)',
    notFoundEmailNotRegistered: 'Cet e-mail n\'est pas enregistré comme utilisateur. Vérifiez la synchronisation avec Azure AD.',
    notFoundUserWithoutMeetings: 'L\'utilisateur existe, mais n\'a participé à aucune réunion enregistrée.',
    notFoundSubjectNoMatches: 'Aucune réunion ne correspond à ce nom.',
    notFoundMeetingNotFound: 'Cette réunion n\'existe plus.',
    notFoundUserDirectoryUnavailable: 'Impossible de consulter l\'annuaire des utilisateurs. Vérifiez si UserAdminService est disponible.',
    matchesTitle: 'Plusieurs réunions correspondent — choisissez-en une',
    matchesSubject: 'Réunion',
    matchesOrganizer: 'Organisateur',
    matchesStatus: 'Statut',
    matchesStarted: 'Début',
    matchesEnded: 'Fin',
    meetingSummary: 'Réunion',
    meetingCorrelation: 'CorrelationId',
    meetingDuration: 'Durée',
    meetingStatus: 'Statut',
    warningsTitle: 'Avertissements',
    stagesTitle: 'Étapes du pipeline',
    stageColOrder: '#',
    stageColName: 'Étape',
    stageColService: 'Service',
    stageColTime: 'Heure',
    stageColOutcome: 'Résultat',
    stageMeetingEnd: 'Fin de la réunion',
    stageMeetingEligibility: 'Éligibilité de la réunion',
    stageParticipantEligibility: 'Éligibilité des participants',
    stageSurveyCreation: 'Création des enquêtes',
    stageNotification: 'Notifications',
    outcomeOk: 'OK',
    outcomeError: 'Erreur',
    outcomeNotEligible: 'Non éligible',
    outcomeNoData: 'Aucune donnée',
    logsTitle: 'Journal brut corrélé',
    logsSubtitle: 'Entrées de MeetingService, SurveyService, AnalyticsService et Bot. NotificationService ne conserve pas de journal brut.',
    logsEmpty: 'Aucune entrée de journal pour cette réunion. Le TTL d\'app_logs est de 24 heures.',
    logsFilterAll: 'Tous',
    logsFilterWarning: 'Warning et plus',
    logsFilterError: 'Erreurs uniquement',
    logsColTime: 'Heure',
    logsColService: 'Service',
    logsColLevel: 'Niveau',
    logsColMessage: 'Message',
  },
  system: {
    title: 'Diagnostic Système',
    subtitle: 'État en temps réel de tous les microservices et workers du backend.',
    refreshAll: 'Tout actualiser',
    refresh: 'Actualiser',
    lastChecked: 'Dernière vérification',
    checking: 'Vérification…',
    never: 'Jamais',
    statusHealthy: 'Sain',
    statusDegraded: 'Dégradé',
    statusError: 'Erreur de connexion',
    showDetails: 'Voir les contrôles',
    hideDetails: 'Masquer les contrôles',
    legendTitle: 'Glossaire des états',
    legendHealthyDesc: 'Tous les contrôles internes du service ont répondu correctement.',
    legendDegradedDesc: 'Le service répond mais MongoDB, Redis ou Service Bus ont signalé une erreur.',
    legendErrorDesc: 'Le service n\'a pas pu être atteint depuis le frontend (timeout, CORS ou service arrêté).',
    checkMongodb: 'MongoDB',
    checkRedis: 'Redis',
    checkServiceBus: 'Service Bus',
    checkSubscriptions: 'Abonnements',
    activeMessages: 'Messages actifs',
    deadLetterMessages: 'Dead Letter',
    environment: 'Environnement',
    version: 'Version',
    workers: 'Workers',
    workersDesc: "État inféré depuis les abonnements Service Bus.",
    analyticsWorker: 'Analytics Worker',
    expirationWorker: 'Expiration Worker',
    noStats: "Aucune statistique d'abonnement disponible.",
    namespace: 'Namespace',
    topic: 'Topic',
    ok: 'OK',
    error: 'Erreur',
  },
  analytics: {
    title: 'Tableau de bord Exécutif',
    subtitle: 'Sigma Pulse Analytics',
    bias: 'Biais',
    omissions: 'Omissions',
    personal: 'Personnel',
    score: 'Score',
    responses: 'Réponses',
    participants: 'Participants',
    period: 'Période',
    ou: 'Unité Organisationnelle',
    noData: 'Données insuffisantes',
    completionRate: 'Taux de complétion',
    avgByCategory: 'Moyenne par catégorie',
    organization: 'Organisation',
    fundamentalsRadar: 'Radar des fondamentaux',
    heatmapOuFund: 'Carte thermique — Score par unité organisationnelle et fondamental',
    moduleInDev: 'Module en développement',
    executiveSubtitle: 'vue exécutive',
    exec: {
      periodAll: "Tout l'historique",
    },
    tabs: { summary: 'Résumé', fundamentals: 'Fondamentaux', heatmap: 'Carte thermique', orgNetwork: 'Réseau org.', generational: 'Générationnel' },
    noScopeTitle: 'Aucune unité organisationnelle attribuée',
    noScopeDesc: "Votre compte n'a aucune unité organisationnelle attribuée, il n'y a donc aucun rapport à afficher. Demandez à l'administrateur central de configurer votre périmètre.",
    filterBar: { allOrg: 'Toute l\'organisation', allMyScope: 'Tout mon périmètre', allBU: 'Toutes les BUs', allDept: 'Tous les Depts', dateFrom: 'Du', dateTo: 'Au', allDimensions: 'Tous les comportements', clearFilters: 'Effacer les filtres' },
    dimensionFilter: {
      partialScope: 'Filtré par « {{dimension}} ». Le taux de réponse, les évaluateurs, les enquêtes par jour et les omissions ne sont pas ventilés par comportement : ils couvrent tout le périmètre.',
      notApplicable: 'Ce bloc n’est pas ventilé par comportement : il s’affiche sans le filtre « {{dimension}} ».',
    },
    kpi: { evaluations: 'Évaluations', avgScore: 'Score moyen', responseRate: 'Taux de réponse', avgPerDay: 'Moy. / jour', evaluators: 'Évaluateurs', scale: 'échelle 1–4', noObservables: 'non observables', perDay: 'enquêtes par jour', activeParticipants: 'participants actifs', ofTotal: 'total', evaluatedPeople_one: '{{count}} personne évaluée', evaluatedPeople_other: '{{count}} personnes évaluées', responseRateSub: 'des enquêtes déjà clôturées' },
    summary: { topBehaviors: 'Top Daily Habits', topDailyHabitsSubtitle: 'Habitudes à fort impact culturel', oppSubtitle: "Habitudes avec plus de marge d'amélioration", opportunities: 'Zones d\'amélioration', omissionsByUnit: 'Omissions par unité', omissionsSubtitle: "Taux d'omission par UO et BU — triées du plus élevé au plus faible · Cliquez sur une UO pour voir ses BUs", downloadExcel: 'Télécharger Excel', omitType: 'Type', omitPeople: 'Personnes', omitRate: "Taux d'omission", noOmissions: 'Aucune omission significative', percentileDistribution: 'Distribution par Percentile', percentileSubtitle: 'Pourcentage de la population dans chaque plage de score', personsEvaluated: 'personnes évaluées', excellent: 'Excellent', good: 'Bon', developing: 'En développement', attention: 'Attention', fundPositioning: 'Positionnement fondamentaux', fundPositioningDesc: 'Classement, score le plus haut/bas et taux non observable par fondamental', highestScore: 'Score le plus élevé', lowestScore: 'Score le plus bas', mostNoObs: 'Plus Non Observable', scoreByOU: 'Score par Unité Organisationnelle', scoreByOUSubtitle: 'Cliquez sur une UO pour voir la répartition par BU et Département', person: 'personne', persons: 'personnes', evaluationsCount_one: '{{count}} évaluation', evaluationsCount_other: '{{count}} évaluations', behaviorPositioningDesc: 'Classement par comportement ; les fondamentaux sans comportements configurés sont affichés en entier', behaviorColumn: 'Comportement', distribution: 'Répartition', omittedSurveys: 'Omises' },
    fundamentals: { title: 'Score par Fondamental', subtitle: 'Développez chaque fondamental pour voir ses daily habits et la répartition par OU', evalLabel: 'éval', confPreliminary: 'Données préliminaires', confBasedOn: 'Basé sur {{n}} éval', behaviorSubtitle: 'Chaque fondamental se décline en comportements ; développez-en un pour voir ses daily habits', noObsCount_one: '{{count}} enquête ne l’a pas évalué', noObsCount_other: '{{count}} enquêtes ne l’ont pas évalué', dailyHabits: 'Daily habits' },
    heatmap: { title: 'Carte thermique culturelle', subtitle: 'Touchez une ligne pour explorer ses sous-unités', unit: 'Unité', unitOU: 'Unité organisationnelle', unitBU: 'Business Unit', unitDept: 'Département', unitPerson: 'Responsable', allOrg: 'Toute l\'organisation', hint: 'Touchez une ligne pour explorer le niveau suivant →', person: 'personne', persons: 'personnes', legendCritical: 'Critique', legendLow: 'Bas', legendMedium: 'Moyen', legendGood: 'Bon', legendExcellent: 'Excellent', noOu: 'Sans UO', behaviorSubtitle: 'Score par unité organisationnelle et comportement ; touchez une ligne pour explorer ses sous-unités', directlyAssigned: 'Rattachés à {{ou}}', hideEmpty_one: 'Masquer {{count}} unité sans données', hideEmpty_other: 'Masquer {{count}} unités sans données', personCount_one: '{{count}} personne', personCount_other: '{{count}} personnes' },
    ona: { title: 'Réseau organisationnel (ONA)', subtitle: 'Arbre interactif des unités organisationnelles (OU)', treeHint: 'Développez chaque nœud pour naviguer les niveaux d\'OU de l\'organisation.', omissions: 'Omissions', totalPeople: 'Personnes', avgScore: 'Score moyen', totalEvals: 'Total évaluations', collaboratorsKpi: 'Collaborateurs', highestOmission: 'Omission max', omissionsRanking: 'Classement omissions', maturityCulture: 'Maturité culturelle', maturityLegend: 'Légende de maturité', maturityInitial: 'Initial', maturityGrowing: 'En développement', maturityConsolidated: 'Consolidé', maturityRoleModel: 'Modèle de rôle', evalsLabel: 'évaluations', noEvals: 'Aucune évaluation', collaboratorsLabel: 'collaborateurs', omissionLabel: 'omission', evalsShort: 'évals', omittedCount_one: '{{count}} omise', omittedCount_other: '{{count}} omises', directlyAssigned: 'Rattachés directement', collaboratorsCount_one: '{{count}} collaborateur', collaboratorsCount_other: '{{count}} collaborateurs', typeBu: 'BU', typeDept: 'Dépt.', typePerson: 'Personne' },
    gen: { panorama: 'Panorama', ranking: 'Classement', brechas: 'Écarts', avgAge: 'Âge moyen', title: 'Analyse Générationnelle', subtitle: 'Distribution et maturité culturelle par cohorte · {{n}} personnes mappées', noRepresentation: 'Sans représentation', scoreLabel: 'Score', omissionLabel: 'Omission', personas: 'personnes', age: 'Âge', all: 'Tous', noData: 'Pas de données pour ce filtre', fundamental: 'Fondamental', gapCol: 'Δ Écart', brechaNote: 'Plus grand écart : {{fund}} · Δ {{delta}} pts entre générations', brechaSource: 'Écart par rapport à la moyenne générale du fondamental dans l\'organisation', responseCount: '{{n}} réponses', personasCount_one: '{{count}} personne', personasCount_other: '{{count}} personnes' },
  },
  userConfig: {
    fabTitle: 'Configurer le profil utilisateur',
    title: 'Profil utilisateur (démo)',
    subtitle: 'Mode test — simule les données qui viendront de Teams SSO lors de l\'intégration',
    nombre: 'Nom',
    correo: 'E-mail',
    ou: 'OU (Unité Organisationnelle)',
    do_: 'DO (Division)',
    bu: 'BU (Unité d\'Affaires)',
    departamento: 'Département',
    puesto: 'Poste',
    numeronomina: 'Numéro d\'employé',
    role: 'Rôle',
    roleDetected: 'Rôle détecté',
    roleNotFound: 'E-mail non trouvé — le rôle Employé sera utilisé',
    save: 'Enregistrer le profil',
    namePlaceholder: 'Ex : Ana García',
    emailPlaceholder: 'Ex : agarcia@sigma.com',
    ouPlaceholder: 'Ex : Technologie',
    doPlaceholder: 'Ex : Direction Technologie',
    buPlaceholder: 'Ex : France',
    deptPlaceholder: 'Ex : Développement Logiciel',
    puestoPlaceholder: 'Ex : Ingénieur Logiciel Sr.',
    nominaPlaceholder: 'Ex : 123456',
    fechaNacimiento: 'Date de naissance',
    tenant: 'Tenant',
  },
  errors: {
    generic: 'Une erreur inattendue est survenue',
    unauthorized: "Vous n'avez pas la permission pour cette action",
    notFound: 'Ressource introuvable',
    network: 'Erreur de connexion. Vérifiez votre réseau.',
  },
  fundamentals: {
    title: 'Fondamentaux',
    subtitle: 'Les comportements que nous mesurons chez Sigma. Ouvrez-en un pour voir ses habitudes quotidiennes.',
    habitsFor: 'Habitudes quotidiennes',
    otherHabits: 'Autres habitudes',
    openHabits: 'Voir les habitudes quotidiennes de {{name}}',
    openMicrosite: 'Ouvrir le microsite de {{name}}',
  },
};

export default fr;

